import { render, staticRenderFns } from "./myhealthyweight.vue?vue&type=template&id=8fc3bbe2&scoped=true&"
import script from "./myhealthyweight.vue?vue&type=script&lang=js&"
export * from "./myhealthyweight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc3bbe2",
  null
  
)

export default component.exports